import { DateTime } from 'luxon';
import { Calendar } from 'data/firestore/agent/calendar/types';

const getHolidaysForDate = (
    calendars: Calendar[],
    date: Date,
    timeZone: string,
) => {
    const displayedDate = DateTime.fromJSDate(date).setZone(timeZone);
    return calendars.flatMap((calendar) => (
        (calendar.holidays || [])
            .filter((holiday) => (
                holiday.month === displayedDate.month
                && holiday.day === displayedDate.day
            ))
            .map((holiday) => ({ ...holiday, calendar }))
    ));
};

export default getHolidaysForDate;
